import { render, staticRenderFns } from "./lista_permisovacacion.vue?vue&type=template&id=9b8192a4&scoped=true"
import script from "./lista_permisovacacion.vue?vue&type=script&lang=js"
export * from "./lista_permisovacacion.vue?vue&type=script&lang=js"
import style0 from "./lista_permisovacacion.vue?vue&type=style&index=0&id=9b8192a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8192a4",
  null
  
)

export default component.exports